import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';

//
export interface DeletionRequest {
  id: number;
}

export interface DeletionResponse extends Response {
  data: null;
}

//
export const deletion = (data: DeletionRequest): Promise<DeletionResponse> => {
  return axios.post(Urls.deleteUrl, {
    ...data,
    commodity_id: data.id,
  });
};

type UseDeleteOptions = {
  config?: MutationConfig<typeof deletion>;
};
//
export const useDelete = ({ config }: UseDeleteOptions) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: deletion,
    ...config,
  });
};
